import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiConfig from '../axiosConfig';

const getUrlParams = (countryCode, categoryId) => {
	let params = {
		countryCode,
	};

	if (!!categoryId && categoryId !== 'all') {
		params['categoryId'] = categoryId;
	}

	return params;
};

export const getProducts = createAsyncThunk(
	'giftSkuManagement/sort/getProducts',
	async ({ countryCode, categoryId = null }) => {
		if (countryCode == null) countryCode = 'my';

		const response = await apiConfig
			.get(`products/`, { params: getUrlParams(countryCode, categoryId) })
			.then((response) => response)
			.catch((error) => error);

		return response.data;
	}
);

export const updateSort = createAsyncThunk(
	'giftSkuManagement/sort/updateProducts',
	async ({ countryCode, categoryId = null, payload }) => {
		if (countryCode == null) countryCode = 'my';

		const response = await apiConfig
			.patch(`products/`, payload, { params: getUrlParams(countryCode, categoryId) })
			.then((response) => response)
			.catch((error) => error);

		return response;
	}
);

const giftSortSkuManagementSlice = createSlice({
	name: 'giftSortSkuManagement',
	initialState: {
		products: [],
	},
	reducers: {},
	extraReducers: {
		[getProducts.fulfilled]: (state, action) => {
			const response = action.payload;
			state.products = response ? response.data : null;
		},
	},
});

export const assetManagementActions = giftSortSkuManagementSlice.actions;
export default giftSortSkuManagementSlice.reducer;
